<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                {
                    text: 'Growth Tasks',
                    disable: false,
                    href: '/#/growthtasks'
                },
                { text: 'Settings', disabled: true }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <!-- Inventory Change Reason Dialog -->
        <InventoryChangeReasonTagEditDialog
            :dialog.sync="inventoryChangeReasonTagEditDialog"
            :object.sync="editedChangeReasonTag"
            :changeReason="editingChangeReasonType"
            v-on:item-created="onInventoryChangeReasonTagAdded"
        >
        </InventoryChangeReasonTagEditDialog>

        <!-- Delete Supplier Dialog -->
        <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedItem"
            v-on:confirmed="deletingConfirmed"
        >
            <template v-slot:title
                >Delete - {{ deletedItem ? deletedItem.tag : "" }}</template
            >
            <template v-slot:content
                >Are you sure you want to delete this item?</template
            >
        </DeleteDialog>

        <v-card class="mx-3 elevation-5">
            <v-tabs centered show-arrows>
                <v-tabs-slider color="primary"></v-tabs-slider>

                <!-- tab header -->
                <v-tab> <v-icon left>call_split</v-icon>Split Reasons </v-tab>
                <v-tab>
                    <v-icon left>filter_1</v-icon>Inventory Change Reasons
                </v-tab>

                <!-- tab body -->
                <!-- Inventory Split Reason -->
                <v-tab-item>
                    <v-card flat>
                        <v-card-title class="pb-0">
                            <v-col cols="12" sm="3"></v-col>

                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="6" class="pl-9">
                                <v-text-field
                                    dense
                                    v-model="searchSplitReason"
                                    append-outer-icon="refresh"
                                    @click:append-outer="
                                        refreshInventoryChangeReasonTagCurrentPage()
                                    "
                                    label="Search"
                                    clearable
                                    hide-details
                                    class="mx-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-btn
                                    v-if="
                                        hasPermission(
                                            'add_inventorychangereasontag'
                                        )
                                    "
                                    color="primary"
                                    outlined
                                    rounded
                                    small
                                    class="mx-2 float-right"
                                    @click="addInventorySplitReasonTag()"
                                    >Add</v-btn
                                >
                            </v-col>
                        </v-card-title>

                        <v-container fluid>
                            <v-data-table
                                :headers="splitReasonHeaders"
                                :search="searchSplitReason"
                                :loading="
                                    $apollo.queries
                                        .tenantInventoryChangeReasonTags.loading
                                "
                                :items="splitReasons"
                                loading-text="Loading... Please wait"
                            >
                                <template v-slot:item.action="{ item }">
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'change_inventorychangereasontag'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        color="primary"
                                        class="mr-2"
                                        @click="
                                            editInventorySplitReasonTag(
                                                item.node
                                            )
                                        "
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'delete_inventorychangereasontag'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        color="error"
                                        @click="
                                            deletingInventoryChangeReasonTag(
                                                item.node
                                            )
                                        "
                                    >
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <!-- <v-icon small @click="deletingProduct(item)">delete</v-icon> -->
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-tab-item>

                <!-- Inventory Manual Reason -->
                <v-tab-item>
                    <v-card flat>
                        <v-card-title class="pb-0">
                            <v-col cols="12" sm="3"></v-col>

                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="6" class="pl-9">
                                <v-text-field
                                    dense
                                    v-model="searchManualReason"
                                    append-outer-icon="refresh"
                                    @click:append-outer="
                                        refreshInventoryChangeReasonTagCurrentPage()
                                    "
                                    label="Search"
                                    clearable
                                    hide-details
                                    class="mx-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-btn
                                    v-if="
                                        hasPermission(
                                            'add_inventorychangereasontag'
                                        )
                                    "
                                    color="primary"
                                    outlined
                                    rounded
                                    small
                                    class="mx-2 float-right"
                                    @click="addInventoryManualReasonTag()"
                                    >Add</v-btn
                                >
                            </v-col>
                        </v-card-title>

                        <v-container fluid>
                            <v-data-table
                                :headers="manualReasonHeaders"
                                :search="searchManualReason"
                                :loading="
                                    $apollo.queries
                                        .tenantInventoryChangeReasonTags.loading
                                "
                                :items="manualReasons"
                                loading-text="Loading... Please wait"
                            >
                                <template v-slot:item.action="{ item }">
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'change_inventorychangereasontag'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        color="primary"
                                        class="mr-2"
                                        @click="
                                            editInventoryManualReasonTag(
                                                item.node
                                            )
                                        "
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'delete_inventorychangereasontag'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        color="error"
                                        @click="
                                            deletingInventoryChangeReasonTag(
                                                item.node
                                            )
                                        "
                                    >
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <!-- <v-icon small @click="deletingProduct(item)">delete</v-icon> -->
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import InventoryChangeReasonTagEditDialog from "@/components/growth/InventoryChangeReasonTagEditDialog.vue";
import DeleteDialog from "@/components/base/DeleteDialog.vue";

export default {
    name: "product-settings-page",
    components: {
        InventoryChangeReasonTagEditDialog,
        DeleteDialog
    },

    apollo: {
        tenantInventoryChangeReasonTags: {
            query: gql`
                query tenantInventoryChangeReasonTags {
                    tenantInventoryChangeReasonTags(orderBy: "tag") {
                        edges {
                            node {
                                id
                                changeReason
                                tag
                            }
                        }
                    }
                }
            `,
            variables() {},
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantInventoryChangeReasonTags
        }
    },

    data: function() {
        return {
            // isLoadingInventory: false,

            inventoryChangeReasonTagEditDialog: false,
            deleteDialog: false,
            searchSplitReason: "",
            searchManualReason: "",

            editedChangeReasonTag: null,
            editingChangeReasonType: null,
            tenantInventoryChangeReasonTags: null,

            // deleted item
            deletedItem: {
                id: null,
                changeReason: null,
                tag: null
            },

            // edited item
            editedInventoryChangeReason: {},

            // table headers
            splitReasonHeaders: [
                {
                    text: "Split Reason",
                    value: "node.tag",
                    sortable: true
                },
                {
                    text: "Action",
                    align: "center",
                    value: "action",
                    width: "120px",
                    sortable: false
                }
            ],
            // table headers
            manualReasonHeaders: [
                {
                    text: "Change Reason",
                    value: "node.tag",
                    sortable: true
                },
                {
                    text: "Action",
                    align: "center",
                    value: "action",
                    width: "120px",
                    sortable: false
                }
            ]
        };
    },
    computed: {
        splitReasons() {
            return this.tenantInventoryChangeReasonTags
                ? this.tenantInventoryChangeReasonTags.edges.filter(item => {
                      return item.node.changeReason === "SPLIT";
                  })
                : [];
        },
        manualReasons() {
            return this.tenantInventoryChangeReasonTags
                ? this.tenantInventoryChangeReasonTags.edges.filter(item => {
                      return item.node.changeReason === "MANUAL";
                  })
                : [];
        }
    },
    watch: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        // split reason
        addInventorySplitReasonTag() {
            this.editingChangeReasonType = "SPLIT";
            this.inventoryChangeReasonTagEditDialog = true;
        },
        editInventorySplitReasonTag(changeReasonTag) {
            this.editedChangeReasonTag = changeReasonTag;
            this.editingChangeReasonType = "SPLIT";
            this.inventoryChangeReasonTagEditDialog = true;
        },
        // manual change reason
        addInventoryManualReasonTag() {
            this.editingChangeReasonType = "MANUAL";
            this.inventoryChangeReasonTagEditDialog = true;
        },
        editInventoryManualReasonTag(changeReasonTag) {
            this.editedChangeReasonTag = changeReasonTag;
            this.editingChangeReasonType = "MANUAL";
            this.inventoryChangeReasonTagEditDialog = true;
        },
        // general
        onInventoryChangeReasonTagAdded() {
            this.editingChangeReasonType = null;
            this.$apollo.queries.tenantInventoryChangeReasonTags.refresh();
        },
        deletingInventoryChangeReasonTag(item) {
            this.deletedItem.type = "change reason";
            this.deletedItem.id = item.id;
            this.deletedItem.tag = item.tag;
            this.deleteDialog = true;
        },

        // delete confirmed
        deletingConfirmed() {
            switch (this.deletedItem.type) {
                case "change reason":
                    this.callDeleteProductCategory();
                    break;
                default:
                    return;
            }
        },

        callDeleteProductCategory() {
            if (this.deletedItem) {
                const payload = {
                    id: this.deletedItem.id
                };

                this.$store
                    .dispatch(
                        "inventoryChangeReasonTag/deleteInventoryChangeReasonTag",
                        payload
                    )
                    .then(response => {
                        // refresh change reason
                        this.$apollo.queries.tenantInventoryChangeReasonTags.refresh();

                        // close delete dialog
                        this.deleteDialog = false;

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: `${response.tag} is deleted!`
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                    });
            }
        },
        refreshInventoryChangeReasonTagCurrentPage() {
            this.$apollo.queries.tenantInventoryChangeReasonTags.refresh();
        }
    }
};
</script>